/**
 * Media Types that the system knows how to injest and theoretically display - think abbreviated mime type
 */
export enum MediaTypes {
  Image = 'Image', // Image file
  Audio = 'Audio', // Audio file
  Video = 'Video', // Video file
  PDF = 'PDF', // PDF Document
  Doc = 'Doc', // Word Document
  Raw = 'Raw', // Unknown, just save it
}

/**
 * Format/encodings supported for images
 */
export enum ImageMediaFormats {
  Jpeg = 'jpeg',
  Png = 'png',
  WebP = 'webp',
}

/**
 * Format/encodings support for audio files
 */
export enum AudioMediaFormats {
  MP3 = 'mp3',
  AAC = 'aac',
  M4A = 'm4a',
  OGG = 'ogg',
}
